var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48566 0 0 4.48609 0 10C0 15.5139 4.48566 20 10 20C15.5143 20 20 15.5139 20 10C20 4.48609 15.5143 0 10 0ZM10 19.1667C4.94547 19.1667 0.83332 15.0545 0.83332 10C0.83332 4.94547 4.94547 0.83332 10 0.83332C15.0545 0.83332 19.1667 4.94547 19.1667 10C19.1667 15.0545 15.0545 19.1667 10 19.1667Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9754 9.64966L8.14211 5.89966C8.01434 5.81626 7.84914 5.81177 7.7173 5.88419C7.58301 5.95743 7.5 6.09743 7.5 6.25001V13.75C7.5 13.9026 7.58301 14.0426 7.7173 14.1158C7.77914 14.1496 7.84832 14.1667 7.91668 14.1667C7.9948 14.1667 8.07375 14.1447 8.14211 14.1004L13.9754 10.3504C14.0943 10.2739 14.1667 10.1416 14.1667 10C14.1667 9.85841 14.0943 9.72618 13.9754 9.64966ZM8.33332 12.9867V7.01337L12.9793 10L8.33332 12.9867Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.44f435dc7e0e8a4521fab686488faa88.svg";
export { ForwardRef as ReactComponent };